import {Shape} from 'diagram-js/lib/model';
import {is} from 'bpmn-js/lib/util/ModelUtil';
import {NeighborhoodHeadNameUpdater} from '@ispm-client/modules/bpmn-modeler/bpmn/utils/neighborhood-head-name-updater';
import {EventType} from '@ispm/shared/bpmn-io/bpmn-js';
import EventBus from 'diagram-js/lib/core/EventBus';

export class PreSaveHandler {

    constructor(private eventBus: EventBus, private neighborhoodHeadNameUpdater: NeighborhoodHeadNameUpdater) {
        this.eventBus.on([EventType.SAVE_START,EventType.START_PREVIEW], () => {
            this.neighborhoodHeadNameUpdater.updateAll();
        });
    }

}
